import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";

import { CreateAWorkspaceHeading, SubHeading } from "../components";

import { ServiceCollectionLogo } from "./components/service-collection-logo";

export const NewUser = () => (
    <SignupBackgroundLayout
        ProductLogo={<ServiceCollectionLogo />}
        theme="yellow"
    >
        <CreateAWorkspaceHeading />
        <SubHeading>
            <FormattedMessage
                id="signup.serviceCollection.newUser"
                defaultMessage="Workspaces are where people organize teams, work, and projects."
            />
        </SubHeading>
        <SiteActivation />
    </SignupBackgroundLayout>
);
